/**
 * upCISO (https://upciso.com) is a NEW service from InventiveHQ, the publisher of this guide, and is still
 * being built. Everything we say about it comes from its own site; keep it modest and edit it HERE.
 * We pass nothing about the person or their incident to upCISO: the links carry only attribution tags.
 */
const UTM = "utm_source=afterabreach&utm_medium=guide&utm_campaign=post-incident"
export const UPCISO = {
  name: "upCISO",
  home: `https://upciso.com/?${UTM}`,
  demo: `https://upciso.com/demo?${UTM}`,
  tools: `https://upciso.com/tools?${UTM}`,
  /** One sentence, from upCISO's own description. */
  blurb: "upCISO is a new compliance-readiness service from InventiveHQ, the publisher of this guide. It is still in development. It helps teams turn security and compliance requirements into a plan: capture systems, data, and obligations, map gaps, link policies and evidence, and track action items with owners and due dates, with crosswalks to NIST CSF and other frameworks.",
  /** Its own limits, said plainly. */
  limits: "upCISO supports readiness and gap analysis. It is not a certification or an independent assessment, and its framework crosswalks don't determine compliance.",
  independence: "You don't need upCISO to use this guide or to improve your security.",
} as const
